webpackJsonp([81],{

/***/ 1321:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1322);


/***/ }),

/***/ 1322:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(170);

var _datetime2 = _interopRequireDefault(_datetime);

var _de = __webpack_require__(768);

var _de2 = _interopRequireDefault(_de);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('de', _de2.default);

/***/ })

},[1321]);


// WEBPACK FOOTER //
// app/datetime.de-1c16d32c5e962ac178fc.js